export const TERMS_AND_CONDITIONS =
  'https://www.flow-solutions.com/hubfs/Agreements%20(internal)/Website%20Terms%20and%20Conditions.pdf';
export const PRIVACY_POLICY =
  'https://www.flow-solutions.com/hubfs/Agreements%20%28internal%29/Privacy%20Policy.pdf';
